import { Navigate, Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/navigation/sidebar'
import { Topbar } from '@/components/navigation/topbar'
import { BottomNav } from '@/components/navigation/bottom-nav'
import { RequestFab } from '@/components/requests/request-fab'
import { useAuth } from '@/hooks/use-auth'
import { useMyProfile } from '@/hooks/use-members'
import { plotDevelopmentStatusLabel } from '@riverpark/utils/plot-development-status'

export function MemberLayout() {
  const { user, isLoading } = useAuth()
  // Only needed to compute the portal label for plain members — staff viewing this same shared
  // self-service layout keep a neutral label, since their own branded portal is elsewhere.
  const { data: profileData } = useMyProfile()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream font-sans text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }

  if (user?.role === 'admin') {
    return <Navigate to="/admin/dashboard" replace />
  }

  const sidebarRole =
    user?.role === 'committee'
      ? 'committee'
      : user?.role === 'estate_manager'
        ? 'estate_manager'
        : 'member'

  const plots = profileData?.data.plots ?? []
  const anyDeveloper = plots.some((p) => p.developmentStatus === 'developer')
  const portalLabel =
    user?.role === 'member'
      ? `${plotDevelopmentStatusLabel(anyDeveloper ? 'developer' : 'owner')} Portal`
      : 'Member Portal'

  return (
    <div className="flex h-screen overflow-hidden bg-cream">
      <Sidebar role={sidebarRole} portalLabel={portalLabel} />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-8 pb-24 lg:pb-8">
          <Outlet />
        </main>
      </div>
      <BottomNav role={sidebarRole} />
      <RequestFab />
    </div>
  )
}
